import jwtService from '@/utils/jwt'

/**
 * MOC相关的API接口
 */
class MocService {
    /**
     * 获取MOC零件列表
     * @param {Object} data - 请求数据，包含sourceid和moccode
     * @returns {Promise<any>} - API响应，包含零件列表
     */
    getMocParts(data) {
        return jwtService.post('/moc/parts', data)
    }

    /**
     * 获取MOC的微信小程序码
     * @param {string} sourceid - 来源ID
     * @param {string} moccode - MOC编号
     * @returns {Promise<Blob>} - 返回图片Blob对象
     */
    getMocWxacode(sourceid, moccode) {
        return jwtService.get(
            `/moc/infowxacode?sourceid=${sourceid}&moccode=${moccode}`,
            {},
            {
                responseType: 'blob'
            }
        )
    }

    /**
     * 获取Bricklink MOC列表
     * @param {Object} params - 查询参数
     * @param {string} [params.userid] - 用户ID
     * @param {string} [params.keyword] - 搜索关键词
     * @param {string} [params.pageindex] - 页码
     * @param {string} [params.sortby] - 排序方式
     * @returns {Promise<any>} - API响应，包含MOC列表
     */
    getBricklinkMocList(params = {}) {
        const queryParams = new URLSearchParams()

        if (params.userid) queryParams.append('userid', params.userid)
        if (params.keyword) queryParams.append('keyword', params.keyword)
        if (params.pageindex) queryParams.append('pageindex', params.pageindex)
        if (params.sortby) queryParams.append('sortby', params.sortby)

        return jwtService.get(`/moc/bricklink/list?${queryParams.toString()}`)
    }

    /**
     * 获取Rebrickable MOC列表
     * @param {Object} params - 查询参数
     * @param {string} [params.author] - 作者
     * @param {string} [params.keyword] - 搜索关键词
     * @param {string} [params.pageindex] - 页码
     * @returns {Promise<any>} - API响应，包含MOC列表
     */
    getRebrickableMocList(params = {}) {
        const queryParams = new URLSearchParams()

        if (params.author) queryParams.append('author', params.author)
        if (params.keyword) queryParams.append('keyword', params.keyword)
        if (params.pageindex) queryParams.append('pageindex', params.pageindex)

        return jwtService.get(`/moc/rebrickable/list?${queryParams.toString()}`)
    }
}

export default new MocService()
